import { render, staticRenderFns } from "./ShippingPackaging.vue?vue&type=template&id=72cf358b&scoped=true"
import script from "./ShippingPackaging.vue?vue&type=script&lang=js"
export * from "./ShippingPackaging.vue?vue&type=script&lang=js"
import style0 from "./ShippingPackaging.vue?vue&type=style&index=0&id=72cf358b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf358b",
  null
  
)

export default component.exports